import { AnimatePresence } from 'framer-motion';
import UserPaymentDetailsFormLayout from './Layout';
import { useCallback } from 'react';
import UserPaymentDetailsFormContent from './Content';
import { useWithdrawSearchParams } from '@starsoft/common/hooks';

/**
 * UserPaymentDetailsForm Component
 * This component is responsible for rendering the user payment details form.
 * It uses the AnimatePresence component from framer-motion to handle animations when the form is displayed or removed.
 *
 * @returns {JSX.Element} The rendered component displaying the user payment details form layout and content.
 *
 * @example
 * // Usage example:
 * <UserPaymentDetailsForm />
 */
export default function UserPaymentDetailsForm() {
  const { userPaymentDetails, handleDeleteWithdrawSearchParams } =
    useWithdrawSearchParams();

  /**
   * onClose Function
   * This function handles the close event of the user payment details form.
   * It deletes the 'user-payment' search parameter when the form is closed.
   *
   * @example
   * // Usage example:
   * onClose();
   */
  const onClose = useCallback(() => {
    handleDeleteWithdrawSearchParams('user-payment');
  }, [handleDeleteWithdrawSearchParams]);

  return (
    <AnimatePresence mode="wait">
      {userPaymentDetails && (
        <UserPaymentDetailsFormLayout onClose={onClose}>
          <UserPaymentDetailsFormContent />
        </UserPaymentDetailsFormLayout>
      )}
    </AnimatePresence>
  );
}
